import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { nowUtil } from '../../../utils/dates/date.utils.ts';
import { YYYY } from '../../../utils/dates/dateFormats.utils.ts';

const GetinsuredFooter = props => {

    const {
        environment: {
            exchangeName,
        },
    } = props;

    const currentYear = nowUtil(YYYY);

    const src = global.__ENV__.PRODUCTION ? '/hix/resources/img/logo_gi_white.png' : '/assets/images/logo_gi_white.png';


    return(
        <Fragment>
            <footer id="footer--gi" className="usa-footer" role="contentinfo">
                <div className="usa-footer-primary-section gi-footer__container">
                    <div className="usa-grid usa-footer__primary-section gi-footer__primary-section">
                        <a href='#' className="gi-footer__image">
                            <img
                                src = { src }
                                alt='GetInsured'
                            />
                        </a>
                        <div className="gi-footer__info">
                            <FormattedMessage id='footer.copyright' values={{  date: currentYear, exchangeName }}/><sup>&#174;</sup>
                        </div>
                    </div>
                </div>
            </footer>
        </Fragment>

    );
};

export default GetinsuredFooter;
